import PropTypes from 'prop-types'
import TextArea from '../../../Nodes/TextArea'
import TextField from '../../../Nodes/TextField'

const text = (props) => {
    const className = 'grid__cell--' + (props.span || '12')

    return (
        <div className={className}>
            { props.type === 'textarea' ? 
                (<TextArea 
                    label={props.name}
                    required={props.required}
                    title={props.title}
                    placeholder={props.placeholder}
                    onChange={props.onInput}
                    value={props.value} />) :
                (<TextField
                    type={props.type}
                    label={props.name}
                    required={props.required}
                    title={props.title}
                    placeholder={props.placeholder}
                    onChange={props.onInput}
                    value={props.value} />) }
        </div>
    )
}

text.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    span: PropTypes.string,
    title: PropTypes.string,
    placeholder: PropTypes.string
}

export default text